module.exports = __webpack_public_path__ + "static/media/timelify-extralight.ec51fc65.otf";